import { get } from 'lodash'

export const getPageSize = (state) => get(state, ['appState', 'pageSize'])

export const getSearchQuery = (state) => get(state, ['appState', 'searchQuery'])

export const getDevicesFilter = (state, filter) => get(state, ['devices', 'filters', filter], '')

export const getIsConfiguredPOSVisible = (state) =>
  get(state, ['appState', 'isConfiguredPOSVisible'])

export const getIsConfiguredPrintersVisible = (state) =>
  get(state, ['appState', 'isConfiguredPrintersVisible'])

export const getIsConfiguredBoardsVisible = (state) =>
  get(state, ['appState', 'isConfiguredBoardsVisible'])

export const getCurrentPaginationPage = (state, screen) =>
  state?.appState?.screenPaginationPage?.[screen]?.page ?? 0

export const getCurrentUserOffset = (state) => state?.appState?.offset ?? 100
